﻿import 'regenerator-runtime/runtime'; // Enable js async/await with parcel and babel.

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import Quasar from 'quasar';
import App from './application/app';

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(Quasar, {
    config: {
        brand: {
            primary: '#002257',
            secondary: '#2A6ED9',
            accent: '#2FCC71',

            dark: '#1D1D1D',

            positive: '#21BA45',
            negative: '#C10015',
            info: '#66B3FF',
            warning: '#F2C037'
        }
    }
});

Vue.prototype.$processException = function (exception) {
    if (exception.ok === false) {
        let message = exception.data.message;
        this.$q.dialog({
            title: 'Error',
            message: message.replaceAll('\r\n', '<br />'),
            html: true
        });

        return;
    }
};

new Vue({
    template: '<App />',
    router: new VueRouter({
        mode: 'history',
        routes: []
    }),
    components: { App }
}).$mount('#app');
